/** Venue-local fields, independent of browser time zone. Reject DST gaps/ambiguous hours. */
export function eventLocal(instant:string,timezone:string):string {
  if(!instant)return '';
  const parts=Object.fromEntries(new Intl.DateTimeFormat('en-US',{timeZone:timezone,year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hourCycle:'h23'}).formatToParts(new Date(instant)).map(p=>[p.type,p.value]));
  return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}`;
}
export function eventInstant(local:string,timezone:string):string {
  const base=Date.parse(`${local}:00Z`);if(!Number.isFinite(base))throw new Error('Choose valid dates and times.');
  const matches:string[]=[];
  // All current IANA offsets are multiples of 15 minutes, within +/-14h.
  for(let offset=-14*60;offset<=14*60;offset+=15){
    const candidate=new Date(base+offset*60_000).toISOString();
    if(eventLocal(candidate,timezone)===local)matches.push(candidate);
  }
  if(matches.length!==1)throw new Error('This time is missing or ambiguous because of daylight saving. Choose another time.');
  return matches[0];
}
